<template>
  <div class="reward-rules">
    <p class="question">{{$t('question')}}</p>
    <div class="answer">
      <p>{{$t('answer')}}</p>
      <img :src="require('../../../static/img/rewardRules/' + $t('img') + '.png')" :alt="$t('img')">
    </div>
  </div>
</template>

<script>
  import locales from './lang.js'

  export default {
    name: 'reward-rules',
    locales
  }
</script>

<style scoped lang="scss">
  .reward-rules {
    max-width: 1180px;
    margin: auto;
    padding: 1.6rem 0 0.86rem;
    color: #666;
    line-height: .2rem;
    .question {
      position: relative;
      color: #111;
      font-weight: 600;
      margin-bottom: 0;
      padding-left: 0.23rem;
      &::before {
        content: 'Q: ';
        position: absolute;
        left: 0;
      }
    }
    .answer {
      position: relative;
      padding: 0.16rem 0 0 0.23rem;
      &::before {
        content: 'A: ';
        position: absolute;
        left: 0;
      }
      p {
        margin-bottom: 0.16rem;
      }
      img {
        max-width: 100%;
      }
    }

    @media (max-width: 1228px) {
      padding: 1.6rem .24rem 0.86rem;
    }

    @media (max-width: 991px) {
      padding: .08rem .24rem 0.8rem;

    }
  }
</style>


// WEBPACK FOOTER //
// rewardRules.vue?0f78b371